import LoginForm from '../components/Login/LoginForm';

const Login = () => {
  return <LoginForm />;
};

export default Login;
